var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 147,
    viewBox: "0 0 147 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10628926 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M86.0371 128.107C116.275 128.107 140.787 103.595 140.787 73.3571C140.787 43.1195 116.275 18.6071 86.0371 18.6071C55.7995 18.6071 31.2871 43.1195 31.2871 73.3571C31.2871 103.595 55.7995 128.107 86.0371 128.107Z",
    fill: "#48B159"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M73.8711 14.0446C41.1671 14.0446 14.5586 40.6531 14.5586 73.3571C14.5586 106.061 41.1671 132.67 73.8711 132.67C106.575 132.67 133.184 106.061 133.184 73.3571C133.184 40.6531 106.575 14.0446 73.8711 14.0446ZM73.8711 123.545C46.198 123.545 23.6836 101.03 23.6836 73.3571C23.6836 45.684 46.198 23.1696 73.8711 23.1696C101.544 23.1696 124.059 45.684 124.059 73.3571C124.059 101.03 101.544 123.545 73.8711 123.545Z",
    fill: "#006449"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M94.7004 52.1871L67.4836 84.8486L52.7619 70.133C50.9795 68.3506 48.0899 68.3506 46.3075 70.133C44.5251 71.9154 44.5251 74.805 46.3075 76.5874L62.1972 92.4771C63.6146 93.9066 65.5673 94.7096 67.5809 94.7096H67.9094C70.0447 94.6123 72.0522 93.6207 73.4209 91.9782L101.702 58.0332C103.321 56.0987 103.059 53.2213 101.118 51.6092C99.1778 49.9971 96.3064 50.2526 94.6883 52.1932L94.7004 52.1871Z",
    fill: "#006449"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickIcon);
export default __webpack_public_path__ + "static/media/GreenTickIcon.5308849079652c37a2076d9002bfce68.svg";
export { ForwardRef as ReactComponent };